export default "__VITE_ASSET__f95d9013__"